import React from "react";
import Agendadas from './agendadas';
import Acl from '../../utils/acl';

function AgendadasFunctionalWrapper(props) {
    const exibirAvancado = Acl.can("organizador.nova-sessao.avancado", true);
    return (
        <Agendadas sessaoFormExibirSessaoAvancado={exibirAvancado} />
    );
}

export default AgendadasFunctionalWrapper;